import React from 'react';
import styled from 'styled-components'
import Avatar from '../../Components/Avatar';
import Loader from '../../Components/Loader';
import NormalText from '../../Components/NormalText';
import Button from '../../Components/Button';

export default({
    data,
    loading,
    onClick
})=>{
  
    if(loading){
        return(
            <Wrapper>
                <Loader />
            </Wrapper>
        )
    }else if(!loading && data){
        return (
          <Wrapper>
            <BigBox>
              <AvatarBox>
                <Avatar url={data.isMe.profileImageUrl} size={"lg"} />
                <NickNameText text={data.isMe.displayName} />
              </AvatarBox>
              <ContentsBox>
                  <NormalText text={"기타 기능 준비중...🧑‍💻"} />
                  <NormalText text={`필요하신 기능이 있나요?`} />
                  <NormalText text={`의견도 환영합니다 😁😁`} />
                  <CustomText
                    text={"의견 남기기 Go!"}
                    onClick={() => {
                      window.open("https://forms.gle/L91uJFr4uoxDcPzs9");
                    }}
                  />
              </ContentsBox>
              <LogOutBox>
                <LogOutBtn text={"로그아웃"} backgroundColor={"blue"} onClick={onClick}/>
              </LogOutBox>
            </BigBox>
          </Wrapper>
        );
    }
}


const Wrapper = styled.div`
    display:flex;
    align-items:center;
    justify-content:center;
    min-height:80vh;
    width:100%;
`

const BigBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  @media screen and (min-width: 501px) {
    max-width: 32%;
  }
`;
const AvatarBox = styled.div`
    display:flex;
    flex-direction:column;
    align-items:center;
    width:100%;
`

const NickNameText=styled(NormalText)`
    margin-top:10px;
    font-weight:bold;

`

const ContentsBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 50px;
  width: 100%;
  & > * {
    margin-bottom: 20px;
  }
`;

const CustomText = styled(NormalText)`
    cursor:pointer;
    color:${props => props.theme.blueColor};
`
const LogOutBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content:center;
  width:100%;
`;

const LogOutBtn = styled(Button)`
    width:100%;
`
